/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
function changeSlides() {
    let carouselSlides = document.getElementsByClassName("slick-slide");
    for (let slide of carouselSlides) {
        let carouselContent = slide.querySelector(".home-carousel__content");
        const mq = window.matchMedia( "(max-width: 768px)" );
        if (mq.matches) {
            carouselContent.style.background = "transparent";
            carouselContent.style.opacity = "1";
            carouselContent.style.visibility = "visible";
        }
        let textElement = carouselContent.getElementsByTagName("a")[0];
        if (textElement && textElement.textContent.length === 0) {
            textElement.style.display = "none";
            let newA = document.createElement("a");
            newA.setAttribute("href", textElement.getAttribute("href"));
            newA.style.position = "absolute";
            newA.style.top = "0";
            newA.style.left = "0";
            newA.style.width = "100%";
            newA.style.height = "100%";
            slide.appendChild(newA);
        } 
    }
};
$('.home-carousel').on('init', function(event, slick){
    changeSlides();
});
